import Vue from "vue";
import { IShoppingCartContext } from "../../Types";
import { oc } from "ts-optchain";
import {ObjectUtil} from "@/services";



export default Vue.extend({
  name: "PromoCodes",

  props: {
    context: {
      type: Object,
      default: () => {
        return ObjectUtil.createInstance<IShoppingCartContext>();
      }
    }
  },
  computed: {
    promoMessages() {
      return oc(this.context as IShoppingCartContext).cartData.PromotionMessages([]);
    }
  },
  methods: {
    removeCode(codeToRemove: string) {
      this.$emit('remove-promo', codeToRemove);
    },
    getPromoMessage(promo){
      if(promo.Type == 0)
        return "Invalid Promo Code";
      else if(promo.Type == 2)
        return "Promo Successfully Applied";
      else
        return promo.Message;
    },
    getButtonClass(promoType){
      switch(promoType){
        case 0:
          return 'pc__button--danger';
        case 1:
          return 'pc__button--info'
        case 2:
          return 'pc__button--success'
        case 3:
          return 'pc__button--warning'
        default:
          return 'pc__button--danger'
      }
    }
  }
})